import {
  faCheckCircle,
  faXmarkCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { AudioAssistanceButton } from 'view/components/buttons/AudioAssistanceButton';
import { UserInput } from 'view/components/common/UserInput';

interface QuestionFeedbackProps {
  feedback: string;
  teacherView: boolean;
  grade: number;
  onGradeResponse: (grade: number, feedback: string) => void;
}

const QuestionFeedback: React.FC<QuestionFeedbackProps> = ({
  feedback,
  teacherView,
  grade,
  onGradeResponse,
}) => {
  return (
    <>
      {teacherView ? (
        <UserInput
          type="textarea"
          id="test"
          label="Feedback"
          value={feedback}
          onChange={(event) => onGradeResponse(grade, event.target.value)}
        />
      ) : (
        <>
          <div
            className={`question-feedback${grade > 50 ? ' correct' : ' wrong'}`}
          >
            {feedback && feedback !== '' && (
              <>
                <label className="label-normal">{feedback}</label>
                <AudioAssistanceButton
                  className="x-modal-button"
                  text={feedback ?? ''}
                />
              </>
            )}
          </div>
          <FontAwesomeIcon
            className="x-modal-button"
            icon={grade > 50 ? faCheckCircle : faXmarkCircle}
            color={grade > 50 ? 'var(--dark-green)' : 'var(--dark-pink)'}
          />
        </>
      )}
    </>
  );
};

export default QuestionFeedback;
